import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { RoleSurfaceGate } from '@/shared/components/RoleSurfaceGate';
import { GuideDashboardLayout } from '@/features/guide/layouts/GuideDashboardLayout';
import { GuideHomePage } from '@/features/guide/pages/GuideHomePage';
import { GuideBookingsPage } from '@/features/guide/pages/GuideBookingsPage';
import { GuidePastBookingsPage } from '@/features/guide/pages/GuidePastBookingsPage';
import { GuidePricingPage } from '@/features/guide/pages/GuidePricingPage';
import { GuideAvailabilityPage } from '@/features/guide/pages/GuideAvailabilityPage';
import { GuideReviewsPage } from '@/features/guide/pages/GuideReviewsPage';
import { GuideWalletPage } from '@/features/guide-finance/pages/GuideWalletPage';
import { GuideWalletTransactionsPage } from '@/features/guide-finance/pages/GuideWalletTransactionsPage';
import { GuideWithdrawalsPage } from '@/features/guide-finance/pages/GuideWithdrawalsPage';
import { GuideBankAccountsPage } from '@/features/guide-finance/pages/GuideBankAccountsPage';
import { GuideIdentityDashboardPage } from '@/features/guide-identity/pages/GuideIdentityDashboardPage';
import { GuideRewardsPage } from '@/features/guide-rewards/pages/GuideRewardsPage';
import { GUIDE_ROUTES } from '@/features/guide/constants/routes';

export const guideRouteTree = {
  path: '/dashboard',
  element: (
    <RoleSurfaceGate surface="guide">
      <ProtectedRoute requireApprovedGuide requireOnboardingComplete>
        <GuideDashboardLayout />
      </ProtectedRoute>
    </RoleSurfaceGate>
  ),
  children: [
    { index: true, element: <GuideHomePage /> },
    { path: 'bookings', element: <GuideBookingsPage /> },
    { path: 'bookings/past', element: <GuidePastBookingsPage /> },
    { path: 'bookings/:id', element: <GuideBookingsPage /> },
    { path: 'requests', element: <Navigate to={GUIDE_ROUTES.BOOKINGS} replace /> },
    { path: 'requests/:id', element: <Navigate to={GUIDE_ROUTES.BOOKINGS} replace /> },
    { path: 'pricing', element: <GuidePricingPage /> },
    { path: 'availability', element: <GuideAvailabilityPage /> },
    { path: 'reviews', element: <GuideReviewsPage /> },
    { path: 'identity', element: <GuideIdentityDashboardPage /> },
    { path: 'rewards', element: <GuideRewardsPage /> },
    { path: 'wallet', element: <GuideWalletPage /> },
    { path: 'wallet/transactions', element: <GuideWalletTransactionsPage /> },
    { path: 'wallet/withdrawals', element: <GuideWithdrawalsPage /> },
    { path: 'wallet/bank-accounts', element: <GuideBankAccountsPage /> },
    { path: '*', element: <Navigate to={GUIDE_ROUTES.HOME} replace /> },
  ],
};

/** @deprecated Use guideRouteTree */
export const guideDashboardRoutes = guideRouteTree;
